import { initChatAnywhere } from '@vp/chat-anywhere-ubik';

export const ubikEnabledPages = [
  'special offers',
  'my projects',
  'checkout',
  'promotionalproducts:category page',
  'clothingandbags:category page',
  'carepageppag:category page',
  'promotionalproductsfreesamplesforbusinesses:category page',
  'my uploads',
  'design services:hub page',
  'configure - mailing add list',
  'configure - mailing list selection',
  'configure - mailing upload review',
  'configure - mailing shipping',
  'configure - mailing upsell',
  'studio',
  'holidaydesignservices:category page',
];

export const loadRegularChat = (config: { locale: string; tenant?: string; pageName?: string }) => {
  if (config.tenant === 'vcs' || ubikEnabledPages.includes(config.pageName?.toLowerCase() || '')) {
    initChatAnywhere({ locale: config.locale, tenant: config.tenant, pageName: config.pageName || '' });
  }
};
